import { render, staticRenderFns } from "./ProjectOffersListItem.vue?vue&type=template&id=2851622e&scoped=true"
import script from "./ProjectOffersListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectOffersListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectOffersListItem.vue?vue&type=style&index=0&id=2851622e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2851622e",
  null
  
)

export default component.exports